import { render, staticRenderFns } from "./DetailQuickQuoteBreadcrumb.vue?vue&type=template&id=67de9aa4&scoped=true&lang=html&"
import script from "./DetailQuickQuoteBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./DetailQuickQuoteBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./DetailQuickQuoteBreadcrumb.vue?vue&type=style&index=0&id=67de9aa4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67de9aa4",
  null
  
)

export default component.exports